module.exports = __webpack_public_path__ + "node_modules/icheck/skins/minimal/orange@2x.png?4a997518";


//////////////////
// WEBPACK FOOTER
// ./~/icheck/skins/minimal/orange@2x.png
// module id = 3255
// module chunks = 9